export default class BreakPoints {
  static BreakpointSm = 640;
  static BreakpointMd = 768;
  static BreakpointLg = 1024;
  static BreakpointXl = 1280;
  static BreakpointXXl = 1536;
}
